export default {"src":"/_next/static/media/Heart_Valve_Disease.0343db71.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};